export default {
  data () {
    return {
      currencySymbols: {
        'EUR': '€',
        'USD': '$',
        'AUD': '$',
        'BRL': 'R$',
        'CAD': '$',
        'CRC': '₡',
        'CZK': 'Kč',
        'DKK': 'kr',
        'HKD': '$',
        'HUF': 'Ft',
        'ILS': '₪',
        'JPY': '¥',
        'MYR': 'RM',
        'MXN': '$',
        'NOK': 'kr',
        'NZD': '$',
        'PHP': '₱',
        'PLN': 'zł',
        'GBP': '£',
        'RUB': '₽',
        'SGD': '$',
        'SEK': 'kr',
        'CHF': 'CHF',
        'TWD': 'NT$',
        'THB': '฿'
      },
      currencyEntities: {
        'EUR': '&euro;',
        'USD': '$',
        'AUD': '$',
        'BRL': 'R$',
        'CAD': '$',
        'CRC': '&#8353;',
        'CZK': 'K&#269;',
        'DKK': 'kr',
        'HKD': '$',
        'HUF': 'Ft',
        'ILS': '&#8362;',
        'JPY': '&#165;',
        'MYR': 'RM',
        'MXN': '$',
        'NOK': 'kr',
        'NZD': '$',
        'PHP': '&#8369;',
        'PLN': 'z&#322;',
        'GBP': '£',
        'RUB': '&#8381;',
        'SGD': '$',
        'SEK': 'kr',
        'CHF': 'CHF',
        'TWD': 'NT$',
        'THB': '&#3647;'
      },
      currencyNames: {
        'EUR': 'Euro',
        'USD': 'United States Dollar',
        'AUD': 'Australian Dollar',
        'BRL': 'Brazilian Real',
        'CAD': 'Canadian Dollar',
        'CRC': 'Costa Rican Colón',
        'CZK': 'Czech Koruna',
        'DKK': 'Danish Krone',
        'HKD': 'Hong Kong Dollar',
        'HUF': 'Hungarian Forint',
        'ILS': 'Israeli New Sheqel',
        'JPY': 'Japanese Yen',
        'MYR': 'Malaysian Ringgit',
        'MXN': 'Mexican Peso',
        'NOK': 'Norwegian Krone',
        'NZD': 'New Zealand Dollar',
        'PHP': 'Philippine Peso',
        'PLN': 'Polish Zloty',
        'GBP': 'Pound Sterling',
        'RUB': 'Russian Ruble',
        'SGD': 'Singapore Dollar',
        'SEK': 'Swedish Krona',
        'CHF': 'Swiss Franc',
        'TWD': 'Taiwan New Dollar',
        'THB': 'Thai Baht'
      }
    }
  },
  methods: {
    currencySymbol (currency) {
      return this.currencySymbols[currency] ? this.currencySymbols[currency] : currency
    },
    currencyEntity (currency) {
      return this.currencyEntities[currency] ? this.currencyEntities[currency] : currency
    },
    thousandSeparator(x, separator = ' ') {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator)
    }
  }
}